import { jsx as _jsx } from "react/jsx-runtime";
import { Suspense, useRef, useState, useEffect, } from "react";
import { useIsVisible } from "./hooks";
let timeout;
export const LazyLoadComponent = ({ children, visibilityOffset = "100px", onInit, onMount, onUnMount, skeleton = null, ...restProps }) => {
    const ref = useRef(null);
    const inView = useIsVisible(ref, visibilityOffset);
    const [loaded, setLoaded] = useState(false);
    useEffect(() => {
        onInit?.();
        return () => {
            if (timeout) {
                clearTimeout(timeout);
            }
            onUnMount?.();
        };
    }, []);
    useEffect(() => {
        if (loaded) {
            // deferring it to make sure, onUnMount is not called before onMount
            timeout = setTimeout(() => onMount?.());
        }
    }, [loaded]);
    useEffect(() => {
        setLoaded((prev) => prev || inView);
    }, [inView]);
    return (_jsx("div", { ref: ref, ...restProps, children: loaded ? _jsx(Suspense, { fallback: skeleton, children: children }) : skeleton }));
};
//# sourceMappingURL=lazy-load-component.js.map